import Smart from './smart'

export default Smart